import inRange from "lodash/inRange";
import {
  COLLECTION_PRODUCT_TYPES,
  dsd,
  medley,
  themedBox,
  snacks,
  snacksKit,
  byo,
  swagmagic,
  giftCard,
} from "./constants";

export const isCollectionTypeProduct = (intent) => {
  return COLLECTION_PRODUCT_TYPES.includes(intent);
};

export const isMedleyProduct = (intent) => intent === medley;
export const isThemedBoxProduct = (intent) => intent === themedBox;
export const isSnackOrDSDProduct = (intent) => [dsd, snacks, snacksKit].includes(intent);
export const isByoProduct = (intent) => intent === byo;
export const isSwagProduct = (intent) => intent === swagmagic;
export const isDSDProduct = (intent) => intent === dsd;
export const isGiftCardProduct = (intent) => intent === giftCard;

export const getProductRangeInputFormErrors = ({ maxPrice, minPrice }) => {
  const errors: { [key: string]: string } = {};
  if (+minPrice > +maxPrice) {
    errors.maxPrice = "Should be greater than or equal to minimum price";
  }
  return errors;
};

const getMinMaxQuantityPriceObj = (prices) =>
  prices.reduce(
    (currentMapping, currentPriceObj) => {
      const { min, max } = currentPriceObj;
      if (min === Math.min(currentMapping.minQuantityPriceObj?.min ?? Infinity, min)) {
        currentMapping.minQuantityPriceObj = currentPriceObj;
      }
      if (max === Math.max(currentMapping.maxQuantityPriceObj?.max ?? 0, max)) {
        currentMapping.maxQuantityPriceObj = currentPriceObj;
      }
      return currentMapping;
    },
    {
      minQuantityPriceObj: {},
      maxQuantityPriceObj: {},
    },
  );

export const getPriceFromBulkProduct = (masterVariant, quantity) => {
  const { prices, priceIn: bulkPrice } = masterVariant;
  const { minQuantityPriceObj, maxQuantityPriceObj } = getMinMaxQuantityPriceObj(prices);
  if (prices.length === 0) {
    return bulkPrice;
  }
  if (quantity < minQuantityPriceObj.min) {
    return minQuantityPriceObj.priceIn;
  }
  if (quantity > maxQuantityPriceObj.max) {
    return maxQuantityPriceObj.priceIn;
  }
  const priceRange = prices.find(({ max, min }) => inRange(quantity, min, max + 1));
  if (priceRange) {
    return priceRange.priceIn;
  }
  const priceRangedIndex = prices.findIndex(({ max, min }) => max > quantity && min > quantity);
  return prices?.[priceRangedIndex - 1]?.priceIn || bulkPrice;
};

export const getProductInventoryData = ({
  inventoryData,
  productQty,
  lowStockQty,
  checkDisplayOosLabel = true,
}) => {
  const {
    available: availableQty,
    displayOosLabel,
    inLocker,
    inTransit,
  } = inventoryData?.total || {};

  const isInventorySyncing = checkDisplayOosLabel && !displayOosLabel && !inLocker && !inTransit;
  const isOutOfStock = !isInventorySyncing && availableQty < productQty;
  const isLowStock = availableQty < lowStockQty;

  return {
    isInventorySyncing,
    isOutOfStock,
    isLowStock,
    lockerQty: inLocker || inTransit,
    inLocker,
    inTransit,
  };
};

export const sortColors = (groupedVariantsByColors) =>
  Object.fromEntries(
    Object.entries(groupedVariantsByColors || {}).sort((color1, color2) => {
      const variant1ActiveStatus = color1?.[1]?.[0]?.storeVariant?.active ?? false;
      const variant2ActiveStatus = color2?.[1]?.[0]?.storeVariant?.active ?? false;
      return Number(variant2ActiveStatus) - Number(variant1ActiveStatus);
    }),
  );
